import { render, staticRenderFns } from "./InscritosNuevoFeria.vue?vue&type=template&id=03573e86"
import script from "./InscritosNuevoFeria.vue?vue&type=script&lang=js"
export * from "./InscritosNuevoFeria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports